
import { FuelStop } from '@/generated-clients/myTrips';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import FieldBasicData, { BasicDataKeyValue } from '@components/my-trips/trips-overview/FieldBasicData.vue';
import TagLetterIcon from '@components/shared/icons/TagLetterIcon.vue';
import AppListItem from '@components/new-styleguide/AppListItem.vue';
import { namespace } from 'vuex-class';

const TriplogModule = namespace('Triplog');

@Component({
  name: 'FuelStopField',
  components: {
    FieldBasicData,
    TagLetterIcon,
    AppListItem
  }
})
export default class FuelStopField extends Vue {
  @Prop({ required: true })
  private fuelStop: FuelStop;

  @TriplogModule.Getter('getFuelUnit')
  private fuelUnit: string;

  get value() {
    return { title: 'Tanken', subtitle: this.address, tagIcon: this.tagIcon, letterIcon: this.letterIcon, location: this.redirectToEdit };
  }

  get tagIcon() {
    return { value: 'tag_fuel_tank', color: '#0b6dc4', fill: 'white' };
  }

  get letterIcon() {
    return this.fuelStop.pilot ? { value: this.fuelStop.pilot.initial, color: this.fuelStop.pilot.color, fill: 'white' } : null;
  }

  get address() {
    const { address } = this.fuelStop;
    return `${address.streetLine}, ${address.areaCode} ${address.locality}, ${address.stateRegion}`;
  }

  get basicData(): BasicDataKeyValue[] {
    return [
      { key: ` ${this.fuelUnit}`, value: this.fuelStop.litres },
      { key: ' €', value: this.fuelStop.totalPrice },
      { key: ` ${this.fuelUnit}/100km`, value: this.fuelStop.averageConsumption }
    ];
  }

  get redirectToEdit() {
    return {
      name: 'fuelStopEdit',
      query: { ...this.$route.query, vehicle: this.fuelStop.vehicleId.toString() },
      params: { id: this.fuelStop.id.toString() },
    };
  }
}
